import React from 'react'
import { FormContainer } from './FormStyles';

import TitleSection from 'src/components/TitleSection';
import Cta from 'src/components/Cta';
import { Arrow, WhatsIcon } from 'src/styles/DesignSystem';

const FormContato = () => {
    return (
        <FormContainer>
            <TitleSection > Contato </TitleSection>

            <form>
                <input type="text" placeholder='Nome'/>
                <input type="email" name="" id="" placeholder='E-mail' />
                <input type="text" placeholder='Telefone' />
                <input type="text" placeholder='Assunto' />
                <textarea placeholder='Mensagem' rows='6'></textarea>

                <footer>
                    <Cta >
                        Enviar mensagem
                        <Arrow />
                    </Cta>

                    <a href="https://api.whatsapp.com/message/PBDXCR3XANWVC1?autoload=1&app_absent=0" target="_blank" rel="noopener noreferrer">
                        Entrar em contato
                        <WhatsIcon />
                    </a>
                </footer>
            </form>
        </FormContainer>
    )
}

export default FormContato;